/*
 * Ryan O'Dowd
 * 2024-10-05
 * © Copyright 2024 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
const BORDER_THICKNESS = 12;
const PADDING = BORDER_THICKNESS / 2;

const getStyles = ({fonts, colors, safeAreaInsets}) => {
  return {
    container: {
      position: 'fixed',
      width: '100vw',
      height: '100dvh',
      borderStyle: 'solid',
      borderWidth: BORDER_THICKNESS,
      borderColor: colors.accent,
      zIndex: 100,
      opacity: 0.8,
      pointerEvents: 'none',
    },
    bottomSection: {
      position: 'absolute',
      bottom: 0,
      display: 'flex',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: colors.accent,
      paddingTop: BORDER_THICKNESS,
      paddingRight: PADDING,
      paddingBottom: safeAreaInsets.bottom,
      paddingLeft: PADDING,
      pointerEvents: 'initial',
    },
    masqueradeText: {
      flexGrow: 1,
      color: colors.primaryExtraDark,
      fontFamily: fonts.secondary,
    },
    name: {
      fontFamily: fonts.secondaryBold,
      marginLeft: 8,
    },
  };
};

export default getStyles;
